import PageSEO from "../components/common/PageSEO";
import HeroSlider from "../components/website/HeroSlider";
import CourseSlider from "../components/website/CourseSlider";
import TestimonialsSlider from "../components/website/TestimonialsSlider";
import { OurClientsSlider } from "../components/website/OurClientsSlider";
import { StudentSaySlider } from "../components/website/StudentSaySlider";
import { GalleryBox } from "../components/website/GalleryBox";

export default function Home() {
  return (
    <div>
      <PageSEO slug="/" fallbackTitle="Phonics Power – Home" />

      {/* Visually-hidden page heading: gives the document an <h1> (before the
          hero's <h2>) for correct heading order + SEO, without altering the UI. */}
      <h1 className="sr-only">
        Phonics Power — Phonics, Grammar, Spoken English &amp; Cambridge English
      </h1>

      <HeroSlider />

      <CourseSlider />
      {/* --------------------------------------------------------------------           */}

    <TestimonialsSlider />

      {/* <!-- ------------------------------------------------------------------------------------------------ --> */}
 <GalleryBox />
     
{/* <!-- ----------------------------------------------------------------------------------------- --> */}

        <StudentSaySlider />

{/* <!-- ----------------------------------------------------------------------------------------- --> */}
      <OurClientsSlider />

   
    </div>
  );
}